import api from "..";
import {
  IGetPaymentResponse,
  type IAdyenCheckoutPaymentResponse,
  type IGetReceiptResponse,
} from "./type";

export const getAllPayment = async () => {
  const response = await api.get<IGetPaymentResponse[]>(`/payment`);

  return response.data;
};

export const getPayment = async (id: string) => {
  const response = await api.get<IGetPaymentResponse>(`/payment/${id}`);

  return response.data;
};

export const getPaymentBySid = async (sid: string) => {
  const response = await api.get<IGetPaymentResponse[]>(
    `/payment/subscription/${sid}`
  );

  return response.data;
};

export const getPaymentByPhone = async (
  phone: string,
  start_date: string,
  end_date: string
) => {
  const response = await api.get<IGetPaymentResponse[]>(
    `/payment/payRecord/${phone}?select_start_date=${start_date}&select_end_date=${end_date}`
  );

  return response.data;
};

export const getUnpaidOrFailPaymentByPhone = async (phone: string) => {
  const response = await api.get<IGetPaymentResponse[]>(
    `/payment/payRecordWithFailOrUnpaid/${phone}`
  );

  return response.data;
};

export const adyenCheckoutSingleHourlyPayrecord = async (paymentId: number) => {
  const response = await api.post<IAdyenCheckoutPaymentResponse>(
    `/payment/adyenCheckoutSingleHourlyPayrecord/${paymentId}`
  );

  return response.data;
};

export const getGenerateReceipt = async (token: string) => {
  const response = await api.get<IGetReceiptResponse>(
    `/payment/generateSingleHourlyReceieptPdf/${token}`
  );
  return response.data;
};

export const getPaymentBySubcriptionToken = async (
  token: string,
  userToken: string
) => {
  const response = await api.post<IGetPaymentResponse[]>(
    `/payment/subscriptionPayment/${token}`,
    {},
    {
      headers: {
        authorization: "Bearer " + userToken,
      },
    }
  );

  return response.data;
};
